module.exports = __webpack_public_path__ + "static/media/logo-website.d149c993.png";